export const skills = [
  {
    id: 1,
    title: "HTML5",
    desc: "Writing clean and organized HTML markup for better readability and search engine performance",
    isExpanded: false,
    image: "images/html51.webp",
    content: [
      "Writing Readable Markup",
      "Nesting Structure",
      "Dynamic Elements",
    ],
  },
  {
    id: 2,
    title: "CSS3",
    desc: "Writing modern CSS Wto style and layout web pages",
    isExpanded: false,
    image: "images/css31.webp",
    content: [
      "Layout Using Flexbox",
      "Using Media Queries",
      "Position Elements",
    ],
  },
  {
    id: 3,
    title: "SCSS",
    desc: "Writing modern CSS styles using SASS extension, for more mature, stable, and professional layouts",
    isExpanded: false,
    image: "images/scss1.webp",
    content: [
      "Nesting",
      "Variables and Mixins",
      "Keeping the Code Dry",
    ],
  },
  {
    id: 4,
    title: "Bootstrap",
    desc: "Using Bootstrap development framework for the creation of websites and web apps that is also responsive.",
    isExpanded: false,
    image: "images/bootstrap1.webp",
    content: ["Using Grid System", "Responsive Design"],
  },
  {
    id: 5,
    title: "jQuery",
    desc: "Profesional code using the jQuery library and it's methods that you can call with a single line of code",
    isExpanded: false,
    image: "images/jQuery1.webp",
    content: ["Optimised Implementation", "Event Methods","Animations and Intervals"],
  },
  {
    id: 6,
    title: "Javascript",
    desc: "Profesional JS code following the newest ES6 features and functionalities",
    isExpanded: false,
    image: "images/js1.webp",
    content: [
      "Asynchronous Programming",
      "Functional Programming",
      "Instantiation Patterns",
    ],
  },
  {
    id: 7,
    title: "React",
    desc: "Creating custom components to optimise the code and the user interfaces using reusable UI components",
    isExpanded: false,
    image: "images/react1.webp",
    content: [
      "State and lifecycle",
      "Building Context",
      "Styled components",
    ],
  },
  {
    id: 8,
    title: "Next.js",
    desc: "Using Next.js enforces more structure and gives the developer additional capabilities: like server-side rendering, routing, bundling, and more",
    isExpanded: false,
    image: "images/next-dark1.webp|images/nextjs-white1.webp",
    content: [
      "Server Side Rendering",
      "Data Fetching",
      
    ],
  },
];
